import Container from "@components/Atomic/Container/Container";
import React from "react";

import { clsx } from "clsx";

import FeaturedArticleCard from "./FeaturedArticleCard";

const OuterWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "mx-auto w-full max-w-2xl px-mini py-mega sm:px-maxi md:p-tera",
    )}
  />
);

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "flex flex-wrap md:-mx-mini")}
  />
);

export interface FeaturedArticleProps {
  styles: any;
  articles: any;
}

export function FeaturedArticle({ styles, articles }: FeaturedArticleProps) {
  return (
    <Container styles={styles}>
      <OuterWrapper>
        <Wrapper>
          {articles.map((article) => (
            <FeaturedArticleCard key={article._id} article={article} />
          ))}
        </Wrapper>
      </OuterWrapper>
    </Container>
  );
}
